import { createSlice } from '@reduxjs/toolkit';

export const loaderSlice = createSlice({
	name: 'loader',
	initialState: false,
	reducers: {
		showLoader: () => true,
		hideLoader: () => false,
	},
});
